import Vue from 'vue';
import bus from './bus';
import mask from './mask';

const install = Vue => {
    Object.defineProperties(Vue.prototype, {
        $bus:   { get() { return bus } },
        $mask:  { get() { return mask } },
    });
};

Vue.use(install);
